/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, fmt } from '../twd'

export default ({list=[]} = {}) => {

    let style = {
        fontWeight: 400,
        color: '#767676'
    }
    list.sort( (a,b) => a.speedLevel - b.speedLevel)
    let n = list.length
    let size = n > 5 ? 'modal-lg'
        : n > 2 ? 'modal-md'
        : 'modal-sm'

    return <React.Fragment>
    <div className={"modal-dialog " + size}>
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-mbs-speed-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center vertical-offset-sm">MBS speed information</h3>
            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-mbs-speed-table'
                className="table align-top">
            <tbody>
                <tr>
                    <td style={style}>Interest rate shift</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {a.speedLevel}
                    </td>)}
                </tr>
                <tr>
                    <td style={style}>Speed</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {a.prepayModelValue} {a.prepayModelType}
                    </td>)}
                </tr>
                <tr>
                    <td style={style}>Average life</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {fmt.dur(a.avgLife)}
                    </td>)}
                </tr>
                <tr>
                    <td style={style}>Next principal</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {fmt.mdy(a.firstPrincipal)}
                    </td>)}
                </tr>
                <tr>
                    <td style={style}>Last principal</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {fmt.mdy(a.lastPrincipal)}
                    </td>)}
                </tr>
                <tr>
                    <td style={style}>Yield %</td>
                    {list.map( (a,i) => <td key={i} className="text-right">
                        {fmt.ytw(a.expYield)}
                    </td>)}
                </tr>
            </tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}


